import { render, staticRenderFns } from "./UnlockAlert.vue?vue&type=template&id=25b12040"
import script from "./UnlockAlert.vue?vue&type=script&lang=js"
export * from "./UnlockAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports